import "./foundation.scss";
import $ from "jquery";
import { Foundation } from "foundation-sites/js/foundation.core";
/**
 * Foundation
 *
 * To import a new component from Foundation, import the module and activate the plugin.
 *
 * For example:
 *     import { Accordion } from 'foundation-sites/js/foundation.accordion';
 *     Foundation.plugin(Accordion, 'Accordion');
 *
 * See this file for more component options:
 *     foundation-sites/js/entries/foundation;
 */

Foundation.addToJquery($);
$(document).foundation();
$(document).ready(function () {
  var $realSection = $(".real-section");
  var $nextSection = $(".next-section");
  var viewportHeight = $(window).height();
  var realSectionOffsetTop = $realSection.offset().top;
  var realSectionHeight = $realSection.outerHeight();

  function checkScroll() {
    var scrollTop = $(window).scrollTop();
    var realSectionBottom = realSectionOffsetTop + realSectionHeight;
    var viewportBottom = scrollTop + viewportHeight;

    if (viewportBottom >= realSectionBottom) {
      if ($(window).width() < 651) {
        $realSection.css({
          position: "fixed",
          bottom: "0rem",
          top: "auto",
          width: "100%"
        });
      } else {
        $realSection.css({
          position: "fixed",
          bottom: "0",
          top: "auto",
          width: "100%"
        });
      }
    } else if (scrollTop < realSectionBottom - viewportHeight) {
      $realSection.css({
        position: "absolute",
        bottom: "",
        top: realSectionOffsetTop,
        width: "100%"
      });
    }
  }

  $(window).on("scroll", checkScroll);
  $(window).on("resize", function () {
    viewportHeight = $(window).height();
    realSectionHeight = $realSection.outerHeight();
  });
});